// Use the same editorial ending and interlude timing as the official homepage.
// The source includes a tail beyond the intended final frame.
export function initHomeScene(video, { onMask, canPlay }) {
  let restartTimer;
  let revealTimer;
  let stopped = false;

  function endScene() {
    if (stopped || video.dataset.sceneInterlude === 'true') return;
    video.dataset.sceneInterlude = 'true';
    video.pause();
    onMask(true);
    restartTimer = setTimeout(() => {
      if (stopped) return;
      video.currentTime = 0;
      delete video.dataset.sceneInterlude;
      if (canPlay()) video.play().catch(() => {});
      revealTimer = setTimeout(() => {
        if (!stopped) onMask(false);
      }, 260);
    }, 1450);
  }
  function inspectTime() {
    if (video.currentTime >= 16.783) endScene();
  }
  video.addEventListener('timeupdate', inspectTime);
  video.addEventListener('ended', endScene);
  return () => {
    stopped = true;
    clearTimeout(restartTimer);
    clearTimeout(revealTimer);
    video.removeEventListener('timeupdate', inspectTime);
    video.removeEventListener('ended', endScene);
    delete video.dataset.sceneInterlude;
  };
}
